export * from './tableEditor.component';
